<script>
    export let game;

    /*export let onClick = () => {};*/
    export let onNavigate = () => {};

    function handleClick() {
		if (game.isLive) {
			onNavigate(game.id);
		}
	}
</script>


<div class="relative w-full h-48 rounded-lg overflow-hidden group flex-shrink-0 cursor-pointer" on:click={handleClick}>
    <div    class="absolute inset-0 bg-cover bg-center transition-transform duration-300 group-hover:scale-105 will-change-transform" 
            style="background-image: url({game.image}); transform-origin: center;">
    </div>
    {#if !game.isLive}
        <div class="absolute inset-0 bg-black/60 flex items-center justify-center">
            <span class="text-white text-lg font-semibold">Coming soon</span>
        </div>
    {/if}
    <div class="absolute bottom-0 w-full bg-black/70 text-white p-2 text-center">
        {game.name}
    </div>
</div>
  